import { useLocation } from "react-router-dom";
import { AccademicContent, AcademicDetails } from "../../components/app";

export default function Accademic() {
  let location = useLocation();

  return (
    <>
      {location?.state?.page === "details" ? (
        <AcademicDetails
          dataId={location?.state?.dataId}
          academicId={location?.state?.academicId}
        />
      ) : (
        <AccademicContent />
      )}
    </>
  );
}
